//config/production.js

module.exports = {
    baseURL : process.env.REACT_APP_baseURL,
    PAYPAL_ACCOUNT: process.env.REACT_APP_PAYPAL_ACCOUNT,
    PAYPAL_CLIENT : process.env.REACT_APP_PAYPAL_CLIENT,
    PAYPAL_SECRET : process.env.REACT_APP_PAYPAL_SECRET
} 
    